import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Users from "../pages/Users/Users";
import Login from "../pages/Login/Login";
import Franchaise from "../pages/Franchaise/Franchaise";
import Dealership from "../pages/Dealership/Dealership";
import Sellyoubusiness from "../pages/Sellyourbusiness/Sellyoubusiness";
import Plan from "../pages/Plan/Plan";
import Investor from "../pages/Investor/Investor";
import Dashboard from "../pages/Dashboard/Dashboard";
import ContactUs from "../pages/ContactUs/ContactUs";
import HappyCustomers from "../pages/HappyCustomers/HappyCustomers";
const   AllTypesOfRoutes = () => {
  const [admin, setAdmin] = useState("");
  useEffect(() => {
    const adminData = localStorage.getItem("admindata");

    try {
      console.log('the admin is',adminData)
      const parsedData = JSON.parse(adminData);
      if (parsedData && typeof parsedData === "object") {
        setAdmin(parsedData);
      } else {
        console.error("Invalid admin data structure");
        localStorage.removeItem("admindata");
      }
    } catch (error) {
      console.error("Error parsing admin data:", error);
      localStorage.removeItem("admindata");
    }
  }, []);

  return (
    <div>
      <Routes>
        <Route path="*" element={<PrivateRoute element={<Dashboard />} />} />
        <Route
          path="/dashboard"
          element={<PrivateRoute element={<Dashboard />} />}
        />
        <Route path="/users" element={<PrivateRoute element={<Users />} />} />
        <Route
          path="/franchaise"
          element={<PrivateRoute element={<Franchaise />} />}
        />
        <Route
          path="/dealersip"
          element={<PrivateRoute element={<Dealership />} />}
        />
        <Route
          path="/sellyourbusiness"
          element={<PrivateRoute element={<Sellyoubusiness />} />}
        />
        <Route path="/plans" element={<PrivateRoute element={<Plan />} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verifyotp" element={<Login />} />
        <Route
          path="/investor"
          element={<PrivateRoute element={<Investor />} />}
        />
        <Route
          path="/contact"
          element={<PrivateRoute element={<ContactUs />} />}
        />
        <Route
          path="/happy-customers"
          element={<PrivateRoute element={<HappyCustomers />} />}
        />
      </Routes>
    </div>
  );
};

export default AllTypesOfRoutes;
